module.exports = __webpack_public_path__ + "static/media/clothes-8.1d6dc276.jpg";